import "./ClientRegistrationMedicalHistoryMedicationsSupplimentsComponent.scss";
import * as Yup from "yup";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import {useDispatch, useSelector} from "react-redux";
import {ImageConfig, Misc} from "../../../../constants";
import {IRootReducerState} from "../../../../store/reducers";
import {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../../shared/services";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import _ from "lodash";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import FormikTextAreaComponent
    from "../../../../shared/components/form-controls/formik-text-area/FormikTextAreaComponent";
import {setFormChangesData} from "../../../../store/actions/form-state.action";

interface ClientRegistrationMedicalHistoryMedicationsSupplimentsComponentProps {
    onNext: () => void;
    appointmentId: any;
}


const ClientMedicalSupplementsValidationSchema = Yup.object({
    medications: Yup.object({
        // prescription_medication: Yup.string().required('Comment is required'),
        // non_prescription_medication: Yup.string().required('Comment is required'),
    }),
});

const ClientMedicalSupplementsInitialValues: any = {
    medications: {
        prescription_medication: "",
        non_prescription_medication: "",
    }
};

const ClientRegistrationMedicalHistoryMedicationsSupplimentsComponent = (props: ClientRegistrationMedicalHistoryMedicationsSupplimentsComponentProps) => {

    const {onNext, appointmentId} = props;
    const [clientMedicalSupplementsInitialValues, setClientMedicalSupplementsInitialValues] = useState<any>(_.cloneDeep(ClientMedicalSupplementsInitialValues));
    const dispatch = useDispatch();
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);


    const {
        clientMedicalHistoryDetails,
        isClientMedicalHistoryDetailsLoaded
    } = useSelector((state: IRootReducerState) => state.client);

    useEffect(() => {
        if (clientMedicalHistoryDetails) {
            setClientMedicalSupplementsInitialValues(clientMedicalHistoryDetails);
        }
    }, [clientMedicalHistoryDetails, isClientMedicalHistoryDetailsLoaded]);

    const onSubmit = useCallback((values: any, {setErrors}: FormikHelpers<any>) => {
        const payload = {
            ...values,
            appointment_id: appointmentId ? appointmentId : currentUser?.appointment_id,
        };
        CommonService._client.ClientMedicalHistoryQuestionnaireMedicationSupplementsDetailsSaveAPICall(payload)
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                dispatch(setFormChangesData(false));
                onNext();
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error, true);
            })
    }, [onNext, currentUser?.appointment_id, dispatch, appointmentId]);

    return (
        <div className={'client-registration-medical-history-medications-suppliments-component'}>
            <Formik
                validationSchema={ClientMedicalSupplementsValidationSchema}
                initialValues={clientMedicalSupplementsInitialValues}
                onSubmit={onSubmit}
                validateOnChange={false}
                validateOnBlur={true}
                enableReinitialize={true}
                validateOnMount={true}>
                {({values, isValid, isSubmitting, validateForm, dirty}) => {

                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    useEffect(() => {
                        validateForm();
                        if (dirty) {
                            dispatch(setFormChangesData(true));
                        }
                    }, [validateForm, values, dirty]);
                    return (
                        <Form noValidate={true} className={"t-form"}>
                            <div className={'t-form-controls'}>
                                <div className="ts-row">
                                    <div className="ts-col-12">
                                        <Field name={`medications.prescription_medication`}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikTextAreaComponent
                                                        id={"prescription_input"}
                                                        label={"Please list all prescription medications/supplements you are currently taking: "}
                                                        placeholder={"Enter your comments here"}
                                                        // required={true}
                                                        formikField={field}
                                                        fullWidth={true}
                                                    />
                                                )
                                            }
                                        </Field>
                                        <Field name={`medications.non_prescription_medication`}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikTextAreaComponent
                                                        id={"non_prescription_input"}
                                                        label={"Please list all non-prescription medications/supplements you are currently taking:\n" +
                                                            "\n "}
                                                        placeholder={"Enter your comments here"}
                                                        // required={true}
                                                        formikField={field}
                                                        fullWidth={true}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                </div>
                                <div className="t-form-actions">
                                    <ButtonComponent
                                        id={"submit_btn"}
                                        type={"submit"}
                                        size={'large'}
                                        isLoading={isSubmitting}
                                        disabled={isSubmitting || !isValid}
                                        suffixIcon={<ImageConfig.ArrowRightCircle/>}
                                    >
                                        {(values?.medications?.non_prescription_medication !== '' || values?.medications?.prescription_medication !== '') ?
                                            "Next" : "Skip"}
                                    </ButtonComponent>
                                </div>
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </div>
    );

};

export default ClientRegistrationMedicalHistoryMedicationsSupplimentsComponent;
